import { http } from '@/utils/http.js';
import { orgPath } from '@/utils/paths.js';
import { getCountryName } from '@/utils/names';
import { useSegmentTypes } from '@/composables/useSegmentTypes';

export const TravelApi = {
  tripIndex(query, options = {}) {
    return http.get(`${orgPath()}/trips`, setConfig(query, options)).then((response) => handleTripResponse(response));
  },

  allIndex(query, options = {}) {
    const { segment_type, activity_type } = useSegmentTypes(query);
    const q = {
      ...query,
      segment_type: segment_type.value,
      activity_type: activity_type.value,
    };

    return http
      .get(`${orgPath()}/segments/all`, setConfig(q, options))
      .then((response) => handleSegmentResponse(response));
  },

  flightIndex(query, options = {}) {
    return http
      .get(`${orgPath()}/segments/air`, setConfig(query, options))
      .then((response) => handleSegmentResponse(response));
  },

  hotelIndex(query, options = {}) {
    return http
      .get(`${orgPath()}/segments/hotel`, setConfig(query, options))
      .then((response) => handleSegmentResponse(response));
  },

  railIndex(query, options = {}) {
    return http
      .get(`${orgPath()}/segments/rail`, setConfig(query, options))
      .then((response) => handleSegmentResponse(response));
  },

  carIndex(query, options = {}) {
    return http
      .get(`${orgPath()}/segments/car`, setConfig(query, options))
      .then((response) => handleSegmentResponse(response));
  },

  transportationIndex(query, options = {}) {
    const q = { ...query, activity_type: 'transportation' };
    return http
      .get(`${orgPath()}/segments/activity`, setConfig(q, options))
      .then((response) => handleSegmentResponse(response));
  },

  restaurantIndex(query, options = {}) {
    const q = { ...query, activity_type: 'restaurant' };
    return http
      .get(`${orgPath()}/segments/activity`, setConfig(q, options))
      .then((response) => handleSegmentResponse(response));
  },

  activityIndex(query, options = {}) {
    const q = { ...query, activity_type: 'general' };
    return http
      .get(`${orgPath()}/segments/activity`, setConfig(q, options))
      .then((response) => handleSegmentResponse(response));
  },
};

/**
 * Allow for overriding the axios request config object
 * @param {object} query - url parameters
 * @param {object} [options] - additional axios config options to pass
 */
function setConfig(query, options = {}) {
  return {
    params: query,
    cancelable: true,
    ...options,
  };
}

function handleSegmentResponse(response) {
  if (response.data?.data) {
    response.data.data = normalizeSegments(response.data.data);
  }

  return response.data;
}

/**
 * Normalize and transform the segment response before sending it to the front-end
 * @param {array} segments
 * @returns {array}
 */
function normalizeSegments(segments) {
  if (!Array.isArray(segments)) {
    return segments;
  }

  return segments.map((segment) => {
    segment.country_name = getCountryName(segment.country_code);

    // Hotels never have start/end times. Add estimated times here
    if (segment.type === 'hotel') {
      //TODO: make this more robust
      segment.start_datetime = segment.start_datetime.split('T')[0] + 'T15:00:00+00:00';
      segment.end_datetime = segment.end_datetime.split('T')[0] + 'T11:00:00+00:00';
    }

    return segment;
  });
}

function handleTripResponse(response) {
  if (response.data?.data) {
    response.data.data = transformTrip(response.data.data);
  }

  return response.data;
}

function transformTrip(trips) {
  if (!Array.isArray(trips)) {
    return trips;
  }

  return trips.map((trip) => {
    trip.country_name = getCountryName(trip.country);
    return trip;
  });
}
